import lboIcon from 'assets/images/lbo-white.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { shopConfirm, shopReject } from '../../registration/actions';
import { getCity, getShopId, getShopName } from '../../registration/selectors';

export const ShopIdConfirm = ({ confirm, reject, shopId, shopName, city }) => (
  <div className="modal shop-id-confirm">
    <div>
      <img src={lboIcon} className="enter-shop-id__icon" />
      <h2 className="shop-id-confirm__header">Confirm Licensed Betting Office</h2>
      <h3 className="shop-id-confirm__shop-details">
        {shopId}{(shopName || city) && ' - '}{shopName}{(shopName && city) && ', '}{city}
      </h3>
      <p className="shop-id-confirm__paragraph">Confirm that the above LBO is correct.</p>
      <div className="modal__button-line">
        <Button className="modal__button button--secondary" onClick={reject}>Cancel</Button>
        <Button className="modal__button" onClick={confirm}>Confirm</Button>
      </div>
    </div>
  </div>
);

ShopIdConfirm.propTypes = {
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired,
  shopId: PropTypes.string.isRequired,
  shopName: PropTypes.string,
  city: PropTypes.string
};

const mapStateToProps = state => ({
  shopId: getShopId(state),
  shopName: getShopName(state),
  city: getCity(state)
});

const mapDispatchToProps = {
  confirm: shopConfirm,
  reject: shopReject
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopIdConfirm);
